<template>
  <div class="expandableList">
    <div v-for="(list, index) in data" :key="index" class="expandableList__card">
      <div class="expandableList__card__header">
        <div class="expandableList__card__header__top" @click="goToParentDetail(list)">
          <slot :name="['topcontent', index].join('-')"></slot>
        </div>
        <div class="expandableList__card__header__bot" @click="toggleOpen(index)">
          <span class="available color-pink" v-if="list.media.length > 1">{{list.media.length}} Available Advertisements</span>
          <span class="available color-pink" v-else>{{list.media.length}} Available Advertisement</span>
          <div class="expand">
            <i v-if="isOpen[index]" class="icon-chevronup color-pink"></i> 
            <i v-else class="icon-chevrondown color-pink"></i>
          </div>
        </div>
      </div>
      <div :class="['expandableList__card__close', isOpen[index] ? 'open' : '']">
        <div v-for="(item, index) in list.media" :key="index" class="expandableList__card__channels">
          <adx-expandable-level2 :item="item"  :addButton="addButton" :list="list" :viewPhoto="viewPhotos" 
            :showSaved="buttonSaved" :tagPhoto="tagPhotos"
            @removeFromCampaign="removeFromCampaign"
            @toggleSave="toggleSave"
            @addToCampaign="addToCampaign"
            @goToDetail="goToDetail"
            @previewImage="previewImage"/>
        </div>
        <div v-if="custom" class=expandableList__card__channels>
          <div class="expandableList__card__channels__header">
            <div class="expandableList__card__channels__header__title">
              <span class="strong">Custom Advertisement</span>
            </div>
            <button class="primary btn-regular" @click="customAdvertisement(list)">Add To Order</button>
          </div>
        </div>
      </div>
    </div>
    <div class="emptyState" v-if="isEmpty && !loading">
      <adx-empty-selection />
    </div>
    <div class="expandableList__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import ExpandableLevel2 from '@/components/ExpandableListItems/Level2'
import LabelStatusCustom from '@/components/StatusLabelCustom'

export default {
  name: 'adx-expandable-listitems',
  components: {
    'adx-expandable-level2' : ExpandableLevel2,
    'adx-label-custom' : LabelStatusCustom
  },
  props: {
    data: {
      required: true
    },
    addButton: {
      required: false
    },
    removeButton: {
      required: false
    },
    custom: {
      required: false,
      default: false
    },
    viewPhotos: {
      required: false,
      default: false
    },
    buttonSaved: {
      required: false,
      default: true
    },
    tagPhotos: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      isEmpty: false,
      isOpen: [],
      isLoading: []
    }
  },
  computed: {
    getVisitor: function() {
      return list.traffic * 30 
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.toggleOpen(0)
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    customAdvertisement(list){
      this.$emit('customAdvertisement', list)
    },
    previewImage(item, list){
      this.$emit('previewImage', item, list)
    },
    toggleSave(list, item) {
      this.$emit('toggleSave',list, item)
    },
    addToCampaign(list, item) {
      this.$emit('addToCampaign',list, item)
    },
    removeFromCampaign(item, list){
      this.$emit('removeFromCampaign', item, list)
    },
    toggleOpen(index) {
      this.$set(this.isOpen, index, !this.isOpen[index])
    },
    goToDetail(item, list) {
      this.$emit('goToDetail',item, list)
    },
    goToParentDetail(list) {
      this.$emit('goToParentDetail', list)
    },
    media_type(item, type){
      if (item.media_name.trim() === 'device'){
        return `digital screen`
      } else if (item.media_name.trim() === 'experience branding'){
        if (type.trim() === 'AM'){
          return `lightbox`
        }
        return `experience branding package`
      } else if (item.media_name.trim() === 'screen'){
        if (type.trim() === 'AM'){
          return `lcd`
        } 
        return `office`
      }
      return item.media_name
    },
    category_display(item){
      if (item.trim() === 'airport') {
        return `airport lounge`
      }
      return item
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>